<template>
  <div class="allfooter">
    <el-row :gutter="20">
      <el-col :span="18" :offset="3">
        <div class="index-footer">
          <div class="breadlay">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item class="breaitem" :to="{ path: '/' }">Home</el-breadcrumb-item>
              <el-breadcrumb-item class="breaitem" :to="{ path: '/browse' }">Browse</el-breadcrumb-item>
              <el-breadcrumb-item class="breaitem" :to="{ path: '/functionalities' }">functionalities
              </el-breadcrumb-item>
              <el-breadcrumb-item class="breaitem" :to="{ path: '/deepfusion' }">deepfusion</el-breadcrumb-item>
              <el-breadcrumb-item class="breaitem" :to="{ path: '/download' }">Download</el-breadcrumb-item>
              <el-breadcrumb-item class="breaitem" :to="{ path: '/about' }">About</el-breadcrumb-item>
              <el-breadcrumb-item class="breaitem" :to="{ path: '/help' }">Help</el-breadcrumb-item>
              <el-breadcrumb-item></el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="footer_b">
            <h3>
              <em>Last modified Oct 1, 2022 08:51:01 GMT</em>
              <p style="font-size: 12px;">Fusion Profiling Interactive Analysis</p>
            </h3>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="icp-footer">
      <p style="text-align: center;color: #bcbcbc">
        Copyright© 2022 Xiong Lab
        <br>
        Sun Yat-sen University, Guangzhou, Guangdong, China
      </p>
      <a style="text-align: center;" href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021003175号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFooter"
}
</script>

<style scoped>
.breadcrumb {
  width: 1200px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
}

.breaitem >>> .el-breadcrumb__inner {
  color: #ffffff !important;
}

.allfooter {
  clear: both;
  overflow: hidden;
  padding: 30px 0 34px;
  background: rgb(84, 92, 100);
  width: 100%;
  position: static;
  bottom: 0px;
  z-index: 4;
  box-shadow: rgba(0, 0, 0, .5) 0px 5px 50px;
  display: block;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h3 {
  float: left;
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

em {
  display: block;
  color: #939aa3;
  height: 24px;
  line-height: 24px;
  margin-bottom: 10px;
  font-style: italic;
  font-size: 12px;
  box-sizing: border-box;
}

.footer_b h3 p {
  display: block;
  color: #fff;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  box-sizing: border-box;
}

.index-footer {
  clear: both;
  overflow: hidden;
  padding: 5px 0 34px;
  width: 100%;
  position: static;
  bottom: 0px;
  z-index: 4;
  box-sizing: border-box;
  display: block;
}

.icp-footer {
  clear: both;
  overflow: hidden;
  width: 100%;
  position: static;
  bottom: 0px;
  z-index: 5;
  box-sizing: border-box;
  display: block;
}

p {
  margin: 0 0 10px;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.icp-footer a {
  display: block;
  background-color: transparent;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue